<template>
  <AppRouterLink
    :to="value.object.link"
    class="relative flex aspect-slideMobile w-full px-4 pb-3 md:aspect-slideDesktop md:px-9 md:pb-6"
  >
    <div class="slide-overlay absolute inset-0 z-20 size-full" />
    <UiPicture
      :src="isMdAndDown ? value.mobilePosterImage : value.posterImage"
      :alt="value.object.title"
      :options="{ height: 440 * 1.5 }"
      :size-options="{
        md: { height: 1100 * 1.5 },
        sm: { height: 940 * 1.5 },
        xs: { height: 550 * 1.5 }
      }"
      class="absolute inset-0 z-10 w-full object-cover"
      img-classes="w-full object-cover"
    />

    <div
      class="relative z-20 mt-auto flex w-full flex-col items-center justify-between text-light md:flex-row md:items-end"
    >
      <div class="mb-3 w-full md:mb-0">
        <UiTitle
          severity="h2"
          class="mb-3 line-clamp-3 text-center text-3xl font-medium leading-tight md:mb-3 md:line-clamp-2 md:text-left md:text-[48px]"
        >
          {{ value.object.title }}
        </UiTitle>
        <div class="line-clamp-1">
          <p v-if="isMdAndDown" class="text-center text-xs">
            {{ value.object.venue }}
          </p>
          <p v-else class="font-medium">{{ slideMeta }}</p>
        </div>
      </div>
      <div v-if="isMdAndUp" class="flex flex-col items-center md:ml-9">
        <UiButton
          severity="primary"
          class="mb-3 !rounded-full px-14 py-3.5 !text-[22px] !font-bold"
        >
          {{ slideButtonText }}
        </UiButton>
        <p class="whitespace-nowrap text-center font-medium">
          {{ value.object.date }}
        </p>
      </div>
      <UiObserverHelperButton
        v-else
        :title="value.object.title"
        :visible="true"
        class="mb-3 w-full !p-2 !pl-7"
      >
        <template #title>
          <p class="text-left text-base font-medium text-text-main">{{ slidePrice }}</p>
          <p class="line-clamp-1 text-left text-xs text-text-main">{{ value.object.date }}</p>
        </template>
        <template #button>
          <UiButton
            severity="primary"
            class="w-full whitespace-nowrap !rounded-full py-2.5 !text-xs !font-medium xs:!text-base"
          >
            <p>{{ slideButtonText }}</p>
          </UiButton>
        </template>
      </UiObserverHelperButton>
      <p v-if="isMdAndDown" class="text-xs text-text-secondary">
        {{ slideMeta }}
      </p>
    </div>
  </AppRouterLink>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { checkIsNumber, toRub, useBreakpoint } from '@/6_shared/lib'
import { AppRouterLink, UiButton, UiObserverHelperButton, UiPicture, UiTitle } from '@/6_shared/ui'
import type { Slide } from '../../model'

type PropType = {
  value: Slide
}

const props = defineProps<PropType>()
const {
  md: [isMdAndUp, isMdAndDown]
} = useBreakpoint()

const slideMeta = computed(() =>
  [
    props.value.object.ageCategory,
    props.value.object.category,
    isMdAndUp.value && props.value.object.venue
  ]
    .filter((item) => item)
    .join(' · ')
)

const slidePrice = computed(() => {
  const price = props.value?.object?.price

  const isNumber = checkIsNumber(price ?? '')
  if (price && isNumber) return toRub(price as number)

  return price
})
const slideButtonText = computed(() => {
  if (isMdAndDown.value) return props.value?.object?.buttonTitle || 'Купить билеты'
  else return slidePrice.value
})
</script>

<style scoped>
.slide-overlay {
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0.5) 38%,
    rgba(0, 0, 0, 0) 100%
  );
}
</style>
